module.exports = __webpack_public_path__ + "img/NationalExpressNewProduct.1f06fb64.jpg";